// src/ConsumerApp/api/wallet/wallet.service.js
import { apiClient } from '../apiClient';

export const WalletService = {
  /**
   * 1. Get Wallet Balance
   */
  getWalletBalance: async (customerId) => {
    const response = await apiClient.get(
      `/brickbucket/wallet/get-wallet-balance?customer_id=${customerId}`
    );
    return response.data || response;
  },

  /**
   * 2. Apply Wallet Balance to Bucket / Order
   */
  applyWalletBalance: async (payload) => {
    const response = await apiClient.post(
      '/brickbucket/wallet/apply-wallet-balance',
      payload
    );
    return response.data || response;
  },

  /**
   * 3. Get Wallet History Statement
   */
  getWalletHistory: async (customerId, page = 1, pageSize = 20) => {
    const response = await apiClient.get('/brickbucket/wallet/get-wallet-history', {
      params: {
        customer_id: customerId,
        page,
        page_size: pageSize,
      },
    });
    return response.data || response;
  },
};